export default __webpack_public_path__ + "144e30b89d4851dcdceb3cadc11898e6.woff2";